import React from "react";
import styles from "./styles.module.scss";

export default function Divider({ margin = "0" }) {
  return <hr className={styles.divider} style={{ margin }} />;
}
